import React from 'react'
import styled from 'styled-components'

// icons
import { ArchiveDrawer } from '@styled-icons/remix-fill'

import { Handshake } from '@styled-icons/fa-solid/Handshake'
import { CheckCircleFill } from '@styled-icons/bootstrap/CheckCircleFill'
import { Workspaces } from '@styled-icons/material/Workspaces'

// utils
import th from 'utils/themeHelper'

// styles
import { getPillColors } from 'components/SearchResultsContainer/styles'
import DashCardWrapper from './DashCardWrapper'

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media screen and (min-width: 769px) {
    flex-direction: row;
  }
`

const Heading = styled.h4`
  display: inline-block;
  flex: 1;
  margin: 0;
  vertical-align: middle;
`

const Info = styled.div`
  display: block;
  margin: 20px;
  flex: 2;
`

const InfoFieldLabel = styled.div`
  font-family: ${th('fonts.bold')};
`

const InfoFieldValue = styled.div`
  font-family: ${th('fonts.regular')};
  margin-right: 5px;
`

const Description = styled.div`
  font-family: ${th('fonts.regular')};
  margin-top: 10px;
`

const DescriptionWrapper = styled.div`
  color: ${th('text.mid')};
  line-height: 1.25em;
  margin-top: 30px;
`

const InfoFieldIcon = styled.div`
  margin-right: 10px;

  & > svg {
    height: 20px;
  }
`

const InfoGroup = styled.div`
  min-width: 30%;
`

const InfoGroupRow = styled.div`
  color: ${th('text.mid')};
  line-height: 1.25em;
  margin-bottom: 15px;
`

const InfoGroupRowInner = styled.div`
  display: flex;
  word-break: break-word;
`

const ProgramLogoWrapper = styled.div`
  display: flex;
  flex: 1;
`

const ProgramLogo = styled.img`
  height: 80%;
  margin: auto;
  width: 80%;

  @media screen and (max-width: 769px) {
    margin-bottom: 15px;
  }
`

const TitleWrapper = styled.div`
  display: block;
  margin: 0 0 30px;
`

const Pill = styled.div.withConfig({
  shouldForwardProp: prop => !['bgColor', 'fontColor', 'fullWidth'].includes(prop)
})`
  background: ${props => props.bgColor || th('backgrounds.default')};
  color: ${props => props.fontColor || th('text.dark')};
  border-radius: 3px;
  display: inline-block;
  font-size: 9px;
  margin-left: 10px;
  padding: 4px 5px;
  text-align: center;
  text-transform: uppercase;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
`

const DashProgramCard = ({
  description,
  projects_count,
  workspaces_count,
  partners_count,
  name,
  image_url,
  status
}) => {
  const { bgColor, color } = getPillColors({ key: 'status', value: status })

  return (
    <DashCardWrapper padding="0">
      <ActionsWrapper>
        <Info>
          <TitleWrapper>
            <Heading>{name}</Heading>

            <Pill bgColor={bgColor} fontColor={color}>
              {status}
            </Pill>
          </TitleWrapper>

          <InfoGroup>
            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <CheckCircleFill />
                </InfoFieldIcon>
                <InfoFieldLabel>Programme status</InfoFieldLabel>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Handshake />
                </InfoFieldIcon>
                <InfoFieldValue>{partners_count || '0'}</InfoFieldValue>{' '}
                <InfoFieldLabel>Partners</InfoFieldLabel>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <ArchiveDrawer />
                </InfoFieldIcon>
                <InfoFieldValue>{projects_count || '0'}</InfoFieldValue>
                <InfoFieldLabel>Projects</InfoFieldLabel>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Workspaces />
                </InfoFieldIcon>
                <InfoFieldValue>{workspaces_count || '0'}</InfoFieldValue>
                <InfoFieldLabel>Workspaces</InfoFieldLabel>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <DescriptionWrapper>
              <InfoFieldLabel>Program description</InfoFieldLabel>

              <Description>{description}</Description>
            </DescriptionWrapper>
          </InfoGroup>
        </Info>

        <ProgramLogoWrapper>
          <ProgramLogo src={image_url} />
        </ProgramLogoWrapper>
      </ActionsWrapper>
    </DashCardWrapper>
  )
}

export default DashProgramCard
